export function getReviewsUrl(profileUrl) {
  const separator = profileUrl.includes('#') ? '&' : '#';

  return [profileUrl, 'tab=stories'].join(separator);
}
